import { FC, ReactNode } from 'react'
import { SxProps, Theme, Typography } from '@mui/material'
import Box from '@mui/material/Box'

type Props = {
  title: string
  children: ReactNode
  filter?: ReactNode
  sx?: SxProps<Theme>
}

export const ScreenWrapper: FC<Props> = ({ title, children, filter, sx }) => {
  return (
    <Box sx={[{ padding: (theme: Theme) => theme.spacing(3, 2) }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h3" sx={{ fontWeight: 400 }}>
            {title}
          </Typography>
        </Box>
        <Box>{filter}</Box>
      </Box>
      {children}
    </Box>
  )
}
